<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary">chat</v-icon> {{ $t('operadores.conversacion') }} / <strong>{{cubiculo.identificador}}</strong></h3>
      <v-layout wrap>
        <v-flex xs12>
          <chat-usuario :key="chatKey" :cubiculo="cubiculo.id" :canal="canal_id" @adjuntado="casoAdjuntado"></chat-usuario>
        </v-flex>
      </v-layout>
  </section>
</template>
<script>
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import moment from 'moment';
import ChatUsuario from '@/components/admin/operadores/ChatUsuario';
export default {
  mixins: [validate, token],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.canal_id = this.$route.params.id;
    this.id = this.$route.params.cubiculo;
    this.recuperarPuntoAtencion();
  },
  beforeDestroy () {},
  mounted () {},
  data () {
    return {
      canal_id: 0,
      interval: null,
      filtro: '',
      conectado: false,
      usuario: {id: null},
      cubiculo: {},
      chatKey: 'chat-usuario'
    };
  },
  methods: {
    casoAdjuntado () {
      this.$router.push(`/pendientes`);
    },
    textoCorto (texto) {
      return texto.substr(0, 80);
    },
    formato (fecha) {
      return moment(fecha).format('DD/MM/YYYY HH:mm:ss');
    },
    recuperarPuntoAtencion () {
      this.$service.get(`system/operadores/cubiculo/${this.id}`, {})
      .then(response => {
        if (response) {
          this.cubiculo = response;
        }
      });
    }
  },
  updated () {
    var container = this.$el.querySelector('#conversation');
    container.scrollTop = container.scrollHeight;
  },
  components: {moment, ChatUsuario}
};
</script>
<style src="./chat.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/operadores/Conversacion.vue